import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import nodeinstance from "../../nodeInstance";

const getFinBaladiyaData = createAsyncThunk("api/baladiya?type=2", async (token) => {
    try {
        const response = await nodeinstance.get("/baladiya?type=2", {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data;
    } catch (e) {
        throw new Error(e.message);
    }
});


const FinBaladiyaDataSlice = createSlice({
    name: "absher",
    initialState: {
        data: null,
        error: "",
        status: false,
        isLoading: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getFinBaladiyaData.fulfilled, (state, action) => {
                state.data = action.payload;
                state.isLoading = false;
                state.status = true;
            })
            .addCase(getFinBaladiyaData.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(getFinBaladiyaData.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.error.message;
            });
    },
});

export { getFinBaladiyaData };
export default FinBaladiyaDataSlice.reducer;
